import { render, staticRenderFns } from "./ConciliacaoWizardTabs.vue?vue&type=template&id=6122797b&scoped=true&"
import script from "./ConciliacaoWizardTabs.vue?vue&type=script&lang=js&"
export * from "./ConciliacaoWizardTabs.vue?vue&type=script&lang=js&"
import style0 from "./ConciliacaoWizardTabs.vue?vue&type=style&index=0&id=6122797b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6122797b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VTabItem})
